import PageHeader from 'src/core/ui/PageHeader';
import Footer from 'src/core/ui/helpers/Footer';
import ContentCardsContainer, { CardType, ContentCard } from 'src/core/ui/ContentCard';
import { CustomDataGrid } from 'src/core/tables/CustomDataGrid';
import { generateTablePageButtons } from 'src/core/tables/generateTablePageButtons';
import { useCurrenciesTable } from 'src/pages/settings/admin/currencies/useCurrenciesTable';

export const CurrenciesTablePage = () => {
    const [columns, tableSettings] = useCurrenciesTable();
    return (
        <>
            <PageHeader {...{
                title: "Currencies", subTitle: "Currency descriptions and fixed exchange rates",
                components: generateTablePageButtons(tableSettings),
            }} />
            <ContentCardsContainer>
                <ContentCard cardId="Currencies" cardTypes={[CardType.noHeader]} contentPadding={0}>
                    <CustomDataGrid columns={columns} tableSettings={tableSettings} />
                </ContentCard>
            </ContentCardsContainer>
            <Footer />
        </>
    );
};

export default CurrenciesTablePage;
